module.exports = __webpack_public_path__ + "img/ontime.358591b0.jpg";